import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { Button } from '@shared/components';

const DownloadCalendarModal = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="grid gap-2">
        <p>{t('calendarDownloadDescription')}</p>
        <div className="grid gap-2">
          <Button
            className="w-full"
            key="submit"
            onClick={() => {
              Modal.destroyAll();
            }}
            variant="primary"
          >
            {t('button.ok')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DownloadCalendarModal;
